import { useReleaseMetadata } from "./useReleaseMetadata";

export const useAppVersion = () => {
  const { data } = useReleaseMetadata();
  return data?.app_version || "…";
};